<div class="wizard__wrapper__location">
  <div class="row">
    <div class="col-xl-6 col-lg-6">
      <h2>
        <span>{{ "Location & address" | translate }}</span>
        <span *ngIf="experienceOrigin"
          ><a
            class="origin__icon"
            href="{{ experienceOriginUrl }}"
            target="_blank"
          ></a
        ></span>
      </h2>
      <p class="general__tip">
        <span></span>{{ "Add your desired location" | translate }}
      </p>
      <experience-location
        #experienceLocation
        (locationEmitter)="getLocationEmitter($event)"
        [latitude]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language].latitude
        "
        [longitude]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language]
            .longitude
        "
        [locationAddress]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language]
            .locationAddress
        "
        [locationDesc]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language]
            .locationDescription
        "
        [city]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language].city
        "
        [country]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language].country
        "
        [experience]="experienceId"
        [language]="generalInfoByLang.language"
        [locationName]="
          generalInfoByLang.dataByLang[this.generalInfoByLang.language]
            .locationName
        "
        [disabled]="false"
        [clickBool]="true"
        [draggable]="true"
      >
      </experience-location>

      <div class="btn-group btn--switcher mb-4" role="group">
        <button
          *ngFor="let lang of LANGUAGE | keyvalue"
          (click)="changeLanguage(lang.value)"
          [ngClass]="{
            'button--active': generalInfoByLang.language == lang.value
          }"
          type="button"
          class="btn"
        >
          {{ lang.key }}
        </button>
      </div>
    </div>

    <div class="col-xl-5 offset-xl-1 tips">
      <div
        *ngIf="hasIssue && comments && commentLocation"
        class="general__tips general__tips--red"
      >
        <div *ngFor="let comment of comments; index as i">
          <h2
            *ngIf="!comment.isResolved && comment.type == 'LOCATION'"
            class="text-danger"
          >
            {{ "You have unresolved issues" | translate }}
          </h2>
          <div *ngIf="!comment.isResolved && comment.type == 'LOCATION'">
            <h3>{{ "Location information" | translate }}</h3>
            <p class="text-danger">{{ comment.comment }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
